<template>
  <a-button
    :disabled="disabled"
    :loading="loading"
    :size="size"
    @click="$emit('click', $event)"
    :class="['btn', compClass, className]"
    :type="ghost ? 'link' : 'default'"
  >
    <a-row type="flex" align="middle">
      <a-col>
        <template v-if="icon === 'add'">
          <img :src="Add" alt="Add" />
        </template>
        <template v-else-if="icon === 'remove'">
          <img :src="Remove" alt="Remove" />
        </template>
        <template v-else-if="icon === 'edit-light'">
          <img :src="EditLight" alt="EditLight" />
        </template>
        <template v-else-if="icon === 'edit'">
          <img :src="Edit" alt="Edit" />
        </template>
        <template v-else-if="icon === 'history'">
          <img :src="History" alt="History" />
        </template>
        <template v-else-if="icon === 'import'">
          <img :src="Import" alt="Import" />
        </template>
        <template v-else-if="icon === 'attachment'">
          <img :src="Attachment" alt="Attachment" />
        </template>
        <template v-else-if="icon === 'export'">
          <img :src="Export" alt="Export" />
        </template>
        <template v-else></template>
      </a-col>
      <a-col>
        <slot></slot>
      </a-col>
    </a-row>
  </a-button>
</template>

<style lang="scss" scoped>
.button {
  &-primary {
    color: #fff;
    background-color: #0379b0;
  }
}
</style>

<script>
import { Add, Remove, Import, Edit, EditLight, History, Attachment, Export } from "@/assets";
export default {
  name: "Button",
  props: {
    title: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "default",
    },
    icon: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    ghost: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      Add,
      Remove,
      Import,
      History,
      Edit,
      Attachment,
      EditLight,
      Export,
    };
  },
  computed: {
    compClass: function () {
      return {
        [`btn-${this.type}--disabled`]: this.disabled,
        [`btn-ghost`]: this.ghost,
        [`btn-ghost--disabled`]: this.ghost && this.disabled,
        [`btn-${this.type}`]: this.type,
        [`btn-hide-border`]: !this.border,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  border: none !important;
  border-radius: 6px;

  height: auto;
  &-primary,
  &-create,
  &-import,
  &-edit {
    background: #0379b0 !important;
    color: #ffffff !important;
    &--disabled {
      opacity: 0.8;
    }
  }
  &-remove {
    background: #dd1d3f;
    color: #fff;
  }
  &-ghost {
    background: transparent !important;
    color: #29444f;
    font-weight: 600;
    &--disabled {
      opacity: 0.7;
    }
    :not(.btn-ghost--disabled) {
      &:active,
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  &-dropdown {
    background: rgba(0, 32, 46, 0.07);
    color: #29444f;
  }
}
</style>
